export default __webpack_public_path__ + "static/media/finishedMockup-min.3d73a076.png";